export default [
    {
        path: '/brand',
        component: () => import('../components/pages/brand/Brand.vue') ,
        meta: {
            title: '旗下品牌'
        }
    },
    {
        path: '/Aierke',
        component: () => import('../components/pages/brand/Aierke.vue') ,
        meta: {
            
        }
    },
    {
        path: '/Beiaiqiwei',
        component: () => import('../components/pages/brand/Beiaiqiwei.vue') ,
        meta: {
            
        }
    },
    {
        path: '/Keoukeyou',
        component: () => import('../components/pages/brand/Keoukeyou.vue') ,
        meta: {
            
        }
    }

]